var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm._pType > 1)?_c('div',[(_vm.imageUrl)?_c('img',{staticClass:"flag-image",style:({ width: 50 * _vm.scale + 'px' }),attrs:{"src":_vm.imageUrl}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }